<template>
  <div class="intro">
    <h1 class="intro__title">PLAQUE PSORIASIS</h1>
    <div class="box">
      <div class="intro__sign">Practical Management of Adult Patients With <br>Moderate to Severe
        Plaque Psoriasis: A Peer’s <br>Perspective & Clinical
        Considerations
      </div>
      <img
        v-if="userAgent.device.isMobile"
        v-bind:src="$store.state.s3Link + require('../../assets/home/arrow-down.png')"
        @click="hideScreen"
        width="15"
        height="41"
        class="intro__mouse intro__arrow-down"
      >
      <svg
        v-else
        width="24px"
        height="35px"
        viewBox="0 0 24 35"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        class="intro__mouse"
        @click="hideScreen"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-668.000000, -451.000000)" fill="#FFFFFF">
            <g transform="translate(0.000000, -92.000000)">
              <g transform="translate(668.000000, 543.000000)">
                <path
                  d="M12.0000333,2.31786133 C6.62786266,2.31786133 2.25703722,6.89301758 2.25703722,12.5165332 L2.25703722,22.4834668 C2.25703722,28.1069824 6.62786266,32.6821387 12.0000333,32.6821387 C17.3725367,32.6821387 21.7429628,28.1244141 21.7429628,22.5220898 L21.7429628,12.5165332 C21.7429628,6.89301758 17.3725367,2.31786133 12.0000333,2.31786133 Z M12.0000333,35 C5.38308736,35 0,29.3853027 0,22.4838086 L0,12.5165332 C0,5.61503906 5.38308736,0 12.0000333,0 C18.6165798,0 24,5.61503906 24,12.5165332 L24,22.5220898 C24,29.4023242 18.6165798,35 12.0000333,35 Z"
                ></path>
                <path
                  d="M11,15.7272454 L11,11.2727546 C11,10.5697893 11.4476952,10 12.0000295,10 C12.5523638,10 13,10.5697893 13,11.2727546 L13,15.7272454 C13,16.4302858 12.5523638,17 12.0000295,17 C11.4476952,17 11,16.4302858 11,15.7272454 Z"
                  class="intro__mouse-scroll"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { TweenMax, TimelineMax, Power0 } from 'gsap';
import { debounce } from 'lodash';
// import WheelIndicator from 'wheel-indicator';

TweenMax.defaultEase = Power0.easeNone;

// const indicator = new WheelIndicator();

let tl = null;
let girlEl = null;

export default {
  props: {
    swipe: Number
  },
  data() {
    return {
      scrollDownCount: 0,
      wheelFunc: null,
      girlInited: false
    };
  },
  computed: {
    ...mapState(['userAgent']),
    docW() {
      return this.userAgent.window.width;
    }
  },
  watch: {
    swipe(val) {
      this.scrollDownCount = val;
    },
    scrollDownCount(val) {
      if (this.userAgent.device.isMobile === false) {
        // if its PC
        if (val === 1) {
          this.hideScreen();
        }
      } else {
        switch (val) {
          case 1:
            tl.to(girlEl, 1, {
              y: 0
            });
            break;
          case 2:
            this.hideScreen();
            break;
        }
      }
    },
    docW() {
      if (!this.girlInited) {
        this.initGirlY();
      }
    }
  },
  methods: {
    initGirlY() {
      if (this.girlInited) {
        return;
      }

      this.girlInited = true;

      if (this.userAgent.device.isMobile) {
        TweenMax.set(girlEl, {
          y: parseInt(window.innerHeight * 0.35),
          x: '-4%',
          scaleX: 1.1,
          scaleY: 1.1
        });
      } else {
        TweenMax.set(girlEl, { clearProps: 'all' });
      }
    },
    hideScreen() {
      console.log('hideScreen');
      const firstScreenTL = new TimelineMax({
        onComplete: () => {
          this.$emit('hide-first-screen');
        }
      });

      if (this.wheelFunc !== null) {
        document.removeEventListener('wheel', this.wheelFunc);
      }

      firstScreenTL
        .fromTo(
          '.intro__title',
          0.5,
          { opacity: 1, y: 0 },
          { opacity: 0, y: -100 }
        )
        .fromTo(
          '.intro__sign',
          0.75,
          { opacity: 1, y: 0 },
          { opacity: 0, y: -50 },
          0
        )
        .fromTo('.intro__mouse', 0.5, { opacity: 1 }, { opacity: 0 }, 0);
    },
    wheelHandle(event) {
      if (!this.$store.state.targetIsIsi) {
        let delta;

        if (event.wheelDelta) {
          delta = event.wheelDelta;
        } else {
          delta = -1 * event.deltaY;
        }

        // if we scroll down
        if (delta < 0 && !tl.isActive()) {
          this.scrollDownCount++;
        }
      }
    },
    debouncedWheel: debounce(function(e) {
      this.wheelHandle(e);
    }, 50)
  },
  mounted() {
    girlEl = document.querySelector('.home-hero__girl').parentNode;
    tl = new TimelineMax();

    this.initGirlY();

    // detect scroll down
    if (this.userAgent.screentest && this.$route.query.screen) {
      switch (this.$route.query.screen) {
        case '1':
          tl.to(girlEl, 0, {
            y: 0
          });
          break;
        case '2':
          this.hideScreen();
          break;
      }
    } else {
      this.wheelFunc = debounce(this.wheelHandle, 50, {
        leading: true,
        trailing: false
      });
      document.addEventListener('wheel', this.wheelFunc);
    }
  },
  beforeDestroy() {
    if (this.wheelFunc !== null) {
      document.removeEventListener('wheel', this.wheelFunc);
    }
    this.$store.commit('setHomeIntroInited', true);
  }
};
</script>

<style lang="scss" src="./HomeHeroIntro.scss">
</style>
